<template>
    <div class="display-inline-flex inline-xs">
        <template v-if="hasFingerprint">
            <template v-if="clipboardIsSupported">
                    <v-icon-button
                        v-tooltip="{text: 'Copy Fingerprint', position: 'left'}"
                        type="basic"
                        size="small"
                        class="has-tooltip-left no-padding"
                        @click="copyFingerprint">
                        <v-icon icon="fingerprint"/>
                    </v-icon-button>
                </template>
                <template v-else>
                    <v-icon-button
                        v-tooltip="{text: 'Show Fingerprint'}"
                        type="basic"
                        size="small"
                        class="has-tooltip-left no-padding"
                        @click="showFingerprintModal">
                        <v-icon icon="fingerprint"/>
                    </v-icon-button>
                </template>
        </template>
        <!-- Fingerprint Modal -->
        <v-modal
            v-if="isVisibleFallbackModal"
            title="Fingerprint"
            cancel-label="Close"
            @close="closeFingerprintModal">
            <template slot="contents">
                <p><span class="payment-instrument-card-pan">{{ fingerprint }}</span></p>
                <p class="text-center">You can use this value in blacklists</p>
            </template>
        </v-modal>
    </div>
</template>
<script>
    import Clipboard from '@/common/clipboard';
    import vModal from '@/components/modal/v-modal';
    import {vIcon, vIconButton} from '@/components/form';

    export default {
        name: 'instrument-finger-print',
        components: {
            vIconButton,
            vIcon,
            vModal,
        },
        props: {
            fingerprint: {
                type: [String, null],
                required: false,
                default: null,
            },
        },
        data() {
            return {
                isVisibleFallbackModal: false,
            };
        },
        computed: {
            hasFingerprint() {
                return !!this.fingerprint;
            },
            clipboardIsSupported() {
                return Clipboard.isSupported;
            },
        },
        methods: {
            async copyFingerprint() {
                try {
                    await Clipboard.copy(this.fingerprint);
                    this.$toast.positive(`Fingerprint copied`);
                } catch (error) {
                    this.showFingerprintModal();
                }
            },
            showFingerprintModal() {
                this.isVisibleFallbackModal = true;
            },
            closeFingerprintModal() {
                this.isVisibleFallbackModal = false;
            },
        },
    };
</script>
